import { useQuery } from '@tanstack/react-query';
import { TSMSTemplate } from 'components/FlowBuilder/FlowSidePanels/types';
import smsService from 'services/api/sms.api';

const useSMSTemplates = () => {
  const { data, isLoading, error } = useQuery<TSMSTemplate[], Error>({
    queryKey: ['sms-templates'],
    queryFn: () => smsService.getSMSTemplates(),
    refetchOnWindowFocus: false,
  });

  return {
    smsTemplates: data || [],
    areSMSTemplatesLoading: isLoading,
    smsTemplatesError: error,
  };
};

export default useSMSTemplates;
